import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
import Store from 'store/store';
import { accessNested, joinClasses } from 'utils/utils';
import { navigateInternally } from 'utils/bolt';
import { smoothScrollTo } from 'utils/smoothScroll';
// import s from 'components/bolt/header/header.sss';

export default class Header extends BaseComp.default {

	triggerBurgerBtn(e) {
		const path = accessNested(this.props.appData, 'header.powsterHeader.customBurgerMenu.path');
		const headerData = this.props.headerData || {};
		const showtimesSearchOverlay = headerData.showtimesSearchOverlay;

		if (showtimesSearchOverlay) {
			return super.triggerBurgerBtn();
		}
		
		if (path.startsWith('http') || path.startsWith('mailto:')) {
			let link = document.createElement('a');
			link.href = path;
			link.target = '_blank';
			link.style.display = 'none';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} else if (path === 'scrollTop') {
			smoothScrollTo(document.getElementById('mainScroll'), 0, 300);
		} else {
			const mainScroll = document.getElementById('mainScroll');
			const activePage = Store.get().activePage;
			const isRootPath = activePage?.path === '/';
			if (isRootPath) {
				return smoothScrollTo(mainScroll, 0, 300);
			}

			navigateInternally(path);
		}
	}

}
